/**
 * Created by toomasp on 29.07.2015.
 */

export let directives = angular.module('eservice.core.directives', []);

// validator directives
import {dateRange} from './validation/date-range.directive';
import {email} from './validation/email.directive';
import {regex} from './validation/regex.directive';
import {unique} from './validation/unique.directive';
import {phone} from './validation/phone.directive';
import {valid} from './validation/valid.directive';
import {personCode} from './validation/person-code.directive';
import {url} from './validation/url.directive';

directives
    .directive('daterange', dateRange)
    .directive('email', email)
    .directive('regex', regex)
    .directive('unique', unique)
    .directive('phone', phone)
    .directive('valid', valid)
    .directive('personcode', personCode)
    .directive('url', url)
;

// decorator directives
import {translate} from './decorator/translate.directive';
import {clickOutside} from './decorator/click-outside.directive';
import {autocomplete} from './decorator/autocomplete.directive';
import {datepicker} from './decorator/datepicker.directive';
import {errorMsg} from './decorator/error-message.directive';
import {synced} from './decorator/synced.directive';
import {tooltip} from './decorator/tooltip.directive';
import {scrollto} from './decorator/scroll-to.directive';
import {placeholder} from './decorator/placeholder.directive';
import {ngTap} from './decorator/ng-tap.directive';
import {ngBlur} from './decorator/ng-blur.directive';

directives
    .directive('translate', translate)
    .directive('clickOutside', clickOutside)
    .directive('autocomplete', autocomplete)
    .directive('datepicker', datepicker)
    .directive('errorMsg', errorMsg)
    .directive('synced', synced)
    .directive('tooltip', tooltip)
    .directive('scrollTo', scrollto)
    .directive('placeholder', placeholder)
    .directive('ngTap', ngTap)
    .directive('ngBlur', ngBlur)
;







// WEBPACK FOOTER //
// ./src/main/ui/core/directives/directives.ts